const config = {
    get: (key: string) => {
        const envKey = `REACT_APP_${key}`;
        return process.env[envKey] || ''
    }
}


export default config;